import React, { useState, useEffect, useRef } from 'react';
import AvatarMenu from './AvatarMenu';
import { useGlobalContext } from './GlobalProvider';

const AccountInfo: React.FC = () => {
  const { walletAddress, setWalletAddress, avatarHash, setAvatarHash } = useGlobalContext();

  const [avatar, setAvatar] = useState<string>('V70_cd8OsY0eHnr8MfZamKM9Ph6MQKH3aMRppTUrpcg');
  const [showAvatarMenu, setShowAvatarMenu] = useState<boolean>(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    playMusic();
  }, []);

  const toggleAvatarMenu = () => {
    setShowAvatarMenu((prevState) => !prevState);
  };

  const playMusic = () => {
    if (audioRef.current) {
      audioRef.current.volume = 0.4;
      audioRef.current.play();
    }
  };

  const pauseMusic = () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };

  return (
    <>
      <AvatarMenu showAvatarMenu={showAvatarMenu} setShowAvatarMenu={setShowAvatarMenu} />
      <div className="">
        <footer className="p-1 text-white fixed bottom-0 left-0 w-full z-[300]">
          <div className="flex justify-between items-center h-full relative">
            {/* Avatar Image (Left Side) */}
            <img
              src={"https://g3nm42xkjlpl3f2cz6oxjnhbak7a3lr4rjv3xddy2y46ampenq2q.arweave.net/" + avatarHash}
              alt="Avatar"
              className="rounded-full w-16 h-16 object-cover shadow-md hover:shadow-lg transition-shadow duration-300"
              onClick={toggleAvatarMenu}
            />

            
            {/* <div className="relative w-full h-full">
            {[1, 2, 3].map((buttonNumber, index) => (
                <button
                key={buttonNumber}
                className="bg-blue-500 text-white font-bold px-4 rounded hover:bg-blue-600 m-2"
                style={{
                    left: `${50 + index * 10}%`,
                    transform: 'translateX(-50%)',
                    bottom: `${50 - index * 10}%`,
                }}
                >
                [{buttonNumber}]
                </button>
            ))}
            </div> */}

        <div className="relative w-full h-full">
        <audio ref={audioRef} src="./audio/AO_Game_Jam_2024.mp3" loop />
            {/* <div>
                <button onClick={playMusic}>Play</button>
                <button onClick={pauseMusic}>Pause</button>
            </div> */}
            </div>

            

            {/* "X" Logo (Right Side, Fixed to Bottom) */}
            <div className="absolute bottom-0 right-0 p-4">
                {/* Flex container to position the logos side by side */}
                <div className="flex space-x-4">
                    <a href={"https://x.com/Josh_Burleson"} target="_blank" rel="noopener noreferrer">
                    <img
                        src={"https://arweave.net/wK9bVKnokuRqI-834aoEYcC1UfVTNO5SxilYWC7hIvc"}
                        alt="X Logo"
                        className="w-4 h-4 hover:shadow-md transition-shadow duration-300"
                    />
                    </a>

                    <a href={"https://bazar.arweave.dev/#/profile/4xEHh8AoKvqK3o1AF01Kvbk9qjMkw-Np9RbLthhgECY/collections/"} target="_blank" rel="noopener noreferrer">
                    <img
                        src={"https://arweave.net/EgHnA6WwbdjkvC5Bk4FOYxKHGsBli45cJw758t0jGDw"}
                        alt="BazAR Logo"
                        className="w-4 h-4 hover:shadow-md transition-shadow duration-300"
                    />
                    </a>
                </div>
            </div>

          </div>
        </footer>
      </div>
    </>
  );
};

export default AccountInfo;
